import { useEffect, useState } from 'react'
const contentful = require("contentful");

const client = contentful.createClient({
  space: "ix3dssutiy4l", // space ID
  accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN
});

export const useContentful = () => {
  const [companies, setCompanies] = useState({
    buyers: [],
    brands: [],
  })
  const [products, setProducts] = useState([])
  const [catalogue, setCatalogue] = useState({
    url: "",
    blob: undefined
  })

  useEffect(() => {
    // fetch Companies and sort by type
    getCompanies().then((companies) => {
      const buyersList = [];
      const brandsList = [];
      companies.forEach(item => {
        switch (item.type) {
          case "buyer":
            buyersList.push(item)
            break;
          case "brand":
            brandsList.push(item)
            break;
          default:
            break;
        }
      })
      setCompanies({
        buyers: buyersList,
        brands: brandsList,
      })
    });

    // fetch products
    getProducts().then((products) => setProducts(products));

    // fetch catalogue URL, then fetch File and prepare for download
    getCatalogueUrl().then((url) => {
      fetch(url)
      .then(response => response.blob())
      .then(blob => {
        setCatalogue({
          blob,
          url
        })
      })
      .catch((error) => console.log(error));
    });
  }, [])
  
  const getCatalogueUrl = async () => {
    try {
      const url = await client.getEntry('3n8dezekIolzedEwvMk8Vu',
      {
        select: "fields"
      })
      .then((response) => {
        return response.fields.file.fields.file.url
      })
      
      return url;
    } catch (error) {
      console.log(error)
    }
  }

  const getCompanies = async () => {
    try {
      const brands = await client.getEntries({
        content_type: "company",
        select: "fields"
      }).then((response) => {
        const items = response.items.map((item) => {
          return {
            name: item.fields.name,
            type: item.fields.type,
            img: item.fields.logo.fields.file.url
          }
        })
        return items
      })
      return brands
    } catch (error) {
      console.log(error)
    }
  }

  const getProducts = async () => {
    try {
      const products = await client.getEntries({
        content_type: "product",
        select: "fields"
      }).then((response) => {
        const items = response.items.map((item) => {
          return {
            name: item.fields.name,
            items: [...item.fields.items],
            img: item.fields.image.fields.file.url
          }
        })
        return items
      })
      return products
    } catch (error) {
      console.log(error)
    }
  }

  const downloadCatalogue = (fileName) => {
    const blobURL = URL.createObjectURL(catalogue.blob);
    const a = document.createElement("a");
    a.href = blobURL;
    a.style = "display: none";
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
  }

  return {
    data: {
      companies,
      products,
      catalogue
    },
    actions: {
      downloadCatalogue
    }
  }
}